


 import { Box, Button, TextField } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
const ConsumerForm = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");

  const handleFormSubmit = (values) => {
  //  console.log(values);
  };

  return (
    <Box m="20px">
      <Header title="ADD CONSUMER" subtitle="Register New Agricultural Consumer" />

      <Formik
        onSubmit={handleFormSubmit}
        initialValues={initialValues}
        validationSchema={checkoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
              }}
            >
              {/* Personal Information */}
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Full Name"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.fullName}
                name="fullName"
                error={!!touched.fullName && !!errors.fullName}
                helperText={touched.fullName && errors.fullName}
                sx={{ gridColumn: "span 4" }}
              />
              
              {/* Login Credentials */}
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Login ID"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.loginId}
                name="loginId"
                error={!!touched.loginId && !!errors.loginId}
                helperText={touched.loginId && errors.loginId}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="password"
                label="Login Password"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.loginPassword}
                name="loginPassword"
                error={!!touched.loginPassword && !!errors.loginPassword}
                helperText={touched.loginPassword && errors.loginPassword}
                sx={{ gridColumn: "span 2" }}
              />

              {/* Farm Details */}
              <TextField
                fullWidth
                variant="filled"
                type="number"
                label="Farm Size (acres)"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.farmSize}
                name="farmSize"
                error={!!touched.farmSize && !!errors.farmSize}
                helperText={touched.farmSize && errors.farmSize}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="date"
                label="Date of Installation"
                InputLabelProps={{ shrink: true }}
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.installationDate}
                name="installationDate"
                error={!!touched.installationDate && !!errors.installationDate}
                helperText={touched.installationDate && errors.installationDate}
                sx={{ gridColumn: "span 2" }}
              />

              {/* Contact Information */}
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Contact Number"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.contact}
                name="contact"
                error={!!touched.contact && !!errors.contact}
                helperText={touched.contact && errors.contact}
                sx={{ gridColumn: "span 4" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Serial Number"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.serial_number}
                name="serial_number"
                error={!!touched.serial_number && !!errors.serial_number}
                helperText={touched.serial_number && errors.serial_number}
                sx={{ gridColumn: "span 4" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Farm Address"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.address}
                name="address"
                error={!!touched.address && !!errors.address}
                helperText={touched.address && errors.address}
                sx={{ gridColumn: "span 4" }}
              />

              {/* Agricultural Details */}
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Primary Crops"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.primaryCrops}
                name="primaryCrops"
                error={!!touched.primaryCrops && !!errors.primaryCrops}
                helperText={touched.primaryCrops && errors.primaryCrops}
                sx={{ gridColumn: "span 4" }}
              />
            </Box>
            
            <Box display="flex" justifyContent="end" mt="20px">
              <Button type="submit" color="primary" variant="contained" size="large" fullWidth>
                Register Consumer
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

// Validation Schema
const phoneRegExp = /^(\+91[\-\s]?)?[0]?(91)?[789]\d{9}$/;

const checkoutSchema = yup.object().shape({
  fullName: yup.string().required("Full name is required"),
  loginId: yup.string().required("Login ID is required"),
  loginPassword: yup.string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters"),
  farmSize: yup.number()
    .required("Farm size is required")
    .positive("Must be positive number")
    .max(1000, "Maximum farm size is 1000 acres"),
  installationDate: yup.date()
    .required("Installation date is required")
    .max(new Date(), "Date cannot be in future"),
  contact: yup.string()
    .matches(phoneRegExp, "Invalid Indian phone number")
    .required("Contact number is required"),
  address: yup.string().required("Farm address is required"),
  primaryCrops: yup.string().required("Primary crops information is required"),
});

const initialValues = {
  fullName: "",
  loginId: "",
  loginPassword: "",
  farmSize: "",
  installationDate: "",
  contact: "",
  address: "",
  primaryCrops: "",
};

export default ConsumerForm;
